import { render, staticRenderFns } from "./ViewVehiclesTable.vue?vue&type=template&id=21ed7522&scoped=true"
import script from "./ViewVehiclesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewVehiclesTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViewVehiclesTable.vue?vue&type=style&index=0&id=21ed7522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed7522",
  null
  
)

export default component.exports